module.exports = __webpack_public_path__ + "static/img/big-6.8f4520f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-6.png
// module id = u7n6
// module chunks = 65